import {Button} from '@mui/material';
import arrow from 'assets/img/arrowBtn.svg';
import {useEffect, useState} from 'react';

const BackToTopButton = (props) => {
    const {listTable} = props
    const [showButton, setShowButton] = useState(false);

    const handleScroll = () => {
        const scrollY = window.scrollY;
        setShowButton(scrollY > 150);
    };

    const scrollToTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            {showButton && (
                <Button
                    onClick={scrollToTop}
                    sx={{
                        bottom: listTable?'27px':'87px',
                        right: '20px',
                        width: '40px',
                        height: '40px',
                        zIndex: '8',
                        minWidth: '40px',
                        position: 'fixed',
                        bgcolor: '#FFFFFF !important',
                        border: '1px solid #3CC0C3',
                        borderRadius: '50%',
                        transition: '0.3s ease-in-out',
                    }}>
                    <img src={arrow} style={{rotate: '90deg'}} alt='' />
                </Button>
            )}
        </>
    );
};

export default BackToTopButton;
